// CategoryAside.js
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategories } from '../services/productService';

const CategoryAside = ({filterCategorie}) => {
    const dispatch = useDispatch();
    const {categories} = useSelector((state) => state.categories);

    useEffect(() => {
        dispatch(fetchCategories())
    }, [dispatch]);
    
    const handleChangeCategory = (name)=>{
        filterCategorie(name)
    }
    return (
        <aside>
            <h2>Catégories</h2>
            {categories.map(categorie => (
                <div key={categorie.id}>
                    <input type="checkbox"  onChange={() =>handleChangeCategory(categorie.name)} />
                    <label>{categorie.name}</label>
                </div>
            ))}
        </aside>
    );
}

export default CategoryAside;
